export default "__VITE_ASSET__u$a_4j4i__"